import { AppLink } from '@crm/components'
import { useImportLeads } from '@crm/features/leads/contexts'
import { paths } from '@crm/routes'
import { useLocales } from '@shared/locales'
import { Button, Row, Space } from 'antd'

import 'antd/dist/reset.css'
import { ArrowLeft, ArrowRight } from 'iconsax-react'

type Props = {
  formName: string
  backLink: string
  disabledBackLink?: boolean
  directionNav: boolean
  importButton: boolean
}

export const ImportFormFooter = ({
  formName,
  backLink,
  disabledBackLink = false,
  directionNav,
  importButton
}: Props) => {
  const { t } = useLocales()
  const { isPending } = useImportLeads()

  return (
    <Row className="mt-20" justify="space-between">
      <AppLink to={paths.leadImport.root}>
        <Button disabled={isPending}>{t('buttons.cancel')}</Button>
      </AppLink>

      <Space>
        <AppLink to={backLink}>
          <Button
            type="primary"
            icon={<ArrowLeft size={20} />}
            disabled={disabledBackLink || isPending}
          >
            {t('buttons.previous')}
          </Button>
        </AppLink>

        {directionNav && (
          <Button
            type="primary"
            iconPosition="end"
            icon={<ArrowRight size={20} />}
            htmlType="submit"
            form={formName}
            loading={isPending}
          >
            {t('buttons.next')}
          </Button>
        )}

        {importButton && (
          <Button
            type="primary"
            htmlType="submit"
            form={formName}
            loading={isPending}
          >
            {t('import.start_import')}
          </Button>
        )}
      </Space>
    </Row>
  )
}
